/**
 * `data-pl-reveal[="fade|slide-up|slide-left|slide-right|scale"]` —
 * плавное появление при попадании в viewport через IntersectionObserver.
 *
 * `prefers-reduced-motion: reduce` → только opacity 0 → 1 без transform
 * (функционально элемент должен появиться).
 */

const INIT_FLAG = 'plRevealInitialized';

let observer: IntersectionObserver | null = null;

function getObserver(): IntersectionObserver | null {
  if (observer) return observer;
  if (typeof IntersectionObserver === 'undefined') return null;
  observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          (entry.target as HTMLElement).style.opacity = '1';
          (entry.target as HTMLElement).style.transform = '';
          observer?.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.15 }
  );
  return observer;
}

function variantTransform(value: string): string {
  switch (value) {
    case 'slide-up':
      return 'translateY(20px)';
    case 'slide-left':
      return 'translateX(-20px)';
    case 'slide-right':
      return 'translateX(20px)';
    case 'scale':
      return 'scale(0.95)';
    default:
      return '';
  }
}

function attach(el: HTMLElement): void {
  if (el.dataset[INIT_FLAG]) return;
  el.dataset[INIT_FLAG] = '1';

  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
  const variant = el.getAttribute('data-pl-reveal') || 'fade';
  el.style.transition = 'opacity 600ms ease-out, transform 600ms ease-out';
  el.style.opacity = '0';
  if (!reduced) {
    const transform = variantTransform(variant);
    if (transform) el.style.transform = transform;
  }

  const obs = getObserver();
  if (obs) {
    obs.observe(el);
  } else {
    // IO не поддерживается — показываем сразу.
    el.style.opacity = '1';
    el.style.transform = '';
  }
}

export function initReveal(nodes: NodeListOf<Element> | Element[]): void {
  for (const node of Array.from(nodes)) {
    if (node instanceof HTMLElement) attach(node);
  }
}
